import { getMethodName } from 'containers/Ezlo/EzloMeshbot/utils';
import { NOT_NAME } from 'containers/Ezlo/EzloMeshbot/constants';

/**
 * Determines whether the given block has a `blockOptions.method.name` equal to `"not"`.
 *
 * This is typically used to identify negated logic in a MeshBot "when" block.
 *
 * @param {Object} element - The block element to evaluate.
 * @param {Object} element.blockOptions - Options object of the block.
 * @param {Object} element.blockOptions.method - Method definition inside the block.
 * @returns {boolean} True if the method name is `"not"`, otherwise false.
 *
 * @example
 * isNotSet({ blockOptions: { method: { name: 'not' } } }); // true
 * isNotSet({ blockOptions: { method: { name: 'equal' } } }); // false
 */
export const isNotSet = (element) => getMethodName(element.blockOptions) === NOT_NAME;
